import Reveal from "@/components/Reveal";

export default function WelcomeSection() {
  return (
    <section
      id="selamat-datang"
      data-testid="welcome-section"
      className="border-b border-[#E3EBF3] bg-[#F3F7FB] px-6 py-20 md:px-12 md:py-28"
    >
      <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Sugeng Rawuh Sede#rek LLDIKTI 7
          </p>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.12] text-[#0B2440] md:text-5xl">
            Selamat Datang pada Pusat Informasi Publik{" "}
            <span className="text-[#1479BF]">LLDIKTI Wilayah VII</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="space-y-6 text-[15px] leading-relaxed text-slate-600 md:text-base">
            <p data-testid="welcome-text-1">
              Laman ini berisi informasi mengenai pelayanan informasi publik
              yang disediakan oleh Lembaga Layanan Pendidikan Tinggi Wilayah
              VII sebagai bentuk tanggungjawab dalam menjalankan kewajiban
              organisasi pemerintahan dalam menjamin keterbukaan informasi
              kepada masyarakat.
            </p>
            <p data-testid="welcome-text-2">
              Pusat Informasi Publik LLDIKTI Wilayah VII dikelola oleh Pejabat
              Pengelola Informasi dan Dokumentasi (PPID) dibawah arahan Atasan
              PPID yaitu Kepala LLDIKTI Wilayah VII berdasarkan Undang-Undang
              Nomor 14 Tahun 2008 tentang Keterbukaan Informasi Publik,
              Peraturan Pemerintah Nomor 61 Tahun 2010 sebagai peraturan
              pelaksananya, dan Peraturan Menteri Pendidikan, Kebudayaan,
              Riset, dan Teknologi Republik Indonesia Nomor 69 Tahun 2024
              sebagai peraturan teknis tentang pengelolaan dan pelayanan
              informasi publik di Lingkungan Kementerian Pendidikan,
              Kebudayaan, Riset, dan Teknologi.
            </p>
            <p data-testid="welcome-text-3">
              Seluruh informasi mengenai pelaksanaan tugas dan fungsi LLDIKTI
              Wilayah VII yang perlu diketahui masyarakat, dikoordinasikan
              pada laman ini. Selain itu, masyarakat yang membutuhkan
              informasi publik yang dikelola LLDIKTI Wilayah VII dapat
              mengakses informasi atau mengajukan pelayanan melalui laman ini.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
